import styled from 'styled-components';
import { BREAKPOINTS } from 'common/styles/style-constants';
import { Div } from 'common/styles/oc-styled-components';

export const OfferBannerContainer = styled(Div)`
  position: absolute;
  top: -57px;
  left: 0;
  width: 100%;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    position: relative;
    left: -20px;
    top: -25px;
    width: 100vw;
  }
`;
